import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="no-print mt-auto border-t border-[#232736] py-6 text-xs font-mono text-[#8b92a5]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <span className="font-tech font-bold text-white uppercase tracking-wider">RUNBOOK BUREAU</span>
          <span>// OPERATING PROTOCOLS FOR BUILDERS</span>
        </div>
        <p>Decouple value from hours. Ship today.</p>
      </div>
    </footer>
  );
};
